import axios from 'axios';
import { API_EXCEPTION_MSG, ScrollInfo } from '../../Common';
import {
  API_RESULT_CD,
  BAD_REQUEST,
  CommonRequest,
  CommonResult,
  ConditionItem,
  createApiRequestUrl,
  FORBIDDEN,
  INTERNAL_SERVER_ERROR,
  NOT_FOUND,
  OK,
} from '../Common';
import { StringOrNull } from '../../types';

const URL = createApiRequestUrl('negotiationList');

export interface SearchConditions {
  searchBranch: ConditionItem[];
}

export interface NegotiationListApiRequest extends CommonRequest {
  maskingFlg: string;
  searchBranch?: ConditionItem[];
  scrollInfo?: ScrollInfo;
  sort?: string;
}

export interface NegotiationResultProductInfo {
  commodityCategory: string;
  commodityContract: string;
  negotiationStatus: string;
  contractAccuracy: string;
  commodityBrand: string;
  productId: number;
  negotiationResultActionInfo?: NegotiationResultActionInfo[];
}

export interface NegotiationResultActionInfo {
  nextAction: string;
  actionType: string;
  dayType: string;
  actionDate: string;
  actionTimeType: string;
  actionTimeFrom?: string;
  actionTimeTo?: string;
  externalSystemType?: string;
}

export interface NegotiationResultItem {
  negotiationId?: number;
  customerId?: number;
  /**
   * 自店舗かどうかを判定するフラグ
   * 1 自店舗
   * 1以外 他店舗
   */
  ownStoreFlg: StringOrNull;
  customerNumber?: number;
  customerFullName?: string;
  ordcstmName: string;
  closingSalesmanName: string;
  otherSalesmanName: string;
  ymFlg: string;
  projectCd: string;
  keep: string;
  cncgPrintNo: string;
  tempCd: string;
  dummyFlg?: boolean;
  updateDate: string;
  createDate: string;
  externalSystemLink1: string;
  resurrectionFlg?: number;
  resurrectionDate?: StringOrNull;
  negotiationNote: string;
  negotiationResultProductInfo?: NegotiationResultProductInfo[];
  customerCreateDate?: string;
  customerLatestUpdateDate?: string;
  expirationDate?: string;
  hasNegotiationAttachedFile?: boolean;
}

export interface NegotiationListApiResponse {
  result: CommonResult;
  searchCondition?: SearchConditions;
  negotiationResult?: NegotiationResultItem[];
  scrollInfo?: ScrollInfo;
  hit?: number;
}

export async function negotiationListApi(request: NegotiationListApiRequest): Promise<NegotiationListApiResponse> {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.post(URL, request, { headers });
    const status = response.status;

    switch (status) {
      case OK.status:
        return response.data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);

      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
}
